import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from "dayjs";
import util from "@/libs/util.js";
export default {
  name: "quarter-statistics",
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        status: "",
        code: this.$route.query.code || "",
        usageType: "",
        discountType: "",
        validDays: "",
        distributionType: "",
        triggerCondition: ""
      },
      // 搜索表单

      couponTemplateConfig: {},
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      form: {
        discountType: 0,
        discountRate: '',
        usageType: "",
        validDays: "",
        distributionType: "",
        triggerCondition: "",
        chineseTitle: "",
        englishTitle: "",
        traditionalTitle: "",
        chineseRule: "",
        englishRule: "",
        traditionalRule: ""
      },
      dialogVisible: false,
      // 新增弹窗
      addRules: {
        discountType: [{
          required: true,
          message: "请选择优惠类型",
          trigger: "change"
        }],
        usageType: [{
          required: true,
          message: "请选择使用类别",
          trigger: "change"
        }],
        validDays: [{
          required: true,
          message: "请选择有效天数",
          trigger: "change"
        }],
        distributionType: [{
          required: true,
          message: "请选择发放类型",
          trigger: "change"
        }],
        triggerCondition: [{
          required: true,
          message: "请选择触发条件",
          trigger: "change"
        }],
        chineseTitle: [{
          required: true,
          message: "请输入中文标题",
          trigger: "blur"
        }],
        englishTitle: [{
          required: true,
          message: "请输入英文标题",
          trigger: "blur"
        }],
        traditionalTitle: [{
          required: true,
          message: "请输入繁体标题",
          trigger: "blur"
        }]
      },
      userSearchForm: {
        phone: ""
      },
      userTableLoading: false,
      userList: [],
      // 用户列表
      sendCouponsDialogVisible: false,
      // 定向发放弹窗
      currentRow: {},
      // 当前行
      sendCouponsUserIds: [],
      // 选择的用户id
      sendCouponsLoading: false // 定向发放loading
    };
  },
  computed: {
    usageType: function usageType() {
      var discountType = ["HP", "LM", "TM", "HV"];
      var list = this.couponTemplateConfig.usageType;
      if (this.form.discountType === 0) {
        list = list.filter(function (item) {
          return discountType.includes(item.value);
        });
      }
      return list;
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCouponTemplateConfig();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    "form.discountRate": {
      handler: function handler(val) {
        if (val && !/^(\d*\.?\d{0,1})$/.test(val)) {
          this.form.discountRate = val.slice(0, -1);
        }
      },
      deep: true
    }
  },
  methods: {
    changeDiscountType: function changeDiscountType() {
      var _this2 = this;
      var discountType = ["HP", "LM", "TM", "HV"];
      if (this.form.discountType === 0 && !discountType.includes(this.form.usageType)) {
        this.form.chineseTitle = "";
        this.form.englishTitle = "";
        this.form.traditionalTitle = "";
        this.form.chineseRule = "";
        this.form.englishRule = "";
        this.form.traditionalRule = "";
        this.form.usageType = "";
        this.$nextTick(function () {
          _this2.$refs.addForm.clearValidate();
        });
      }
    },
    discountRateChange: function discountRateChange(val) {
      if (val > 9.9) {
        this.form.discountRate = 9.9;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sendCouponsUserIds = val.map(function (item) {
        return item.id;
      });
    },
    sendCouponsToTargetUsers: function sendCouponsToTargetUsers() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$data$, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(_this3.sendCouponsUserIds.length === 0 || _this3.sendCouponsLoading)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this3.sendCouponsLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return _this3.$api.sendCouponsToTargetUsers({
                adminId: util.cookies.get("uuid"),
                templateId: _this3.currentRow.id,
                userIds: _this3.sendCouponsUserIds
              });
            case 3:
              res = _context2.v;
              _this3.$message.success("发放成功");
              // this.sendCouponsDialogVisible = false;
              _this3.sendCouponsLoading = false;
              _this3.userList = [];
              _this3.userSearchForm = {
                phone: ""
              };
              // 操作上报
              _this3.$operationLog.push({
                code: "singleusertargeting",
                userId: _this3.sendCouponsUserIds[0],
                operationType: "coupon_configure",
                detailBatchNo: (_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.code
              });
              _this3.sendCouponsUserIds = [];
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              _this3.sendCouponsLoading = false;
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 4]]);
      }))();
    },
    showSendCouponsDialog: function showSendCouponsDialog(row) {
      this.currentRow = row;
      this.sendCouponsDialogVisible = true;
      this.userSearchForm = {
        phone: ""
      };
      this.userList = [];
    },
    getUserList: function getUserList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var searchForm, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this4.userList = [];
              if (!(!_this4.userSearchForm.phone || !_this4.userSearchForm.phone.trim())) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              searchForm = {
                pn: 1,
                ps: 200,
                phone: _this4.userSearchForm.phone
              };
              _this4.userTableLoading = true;
              _context3.n = 2;
              return _this4.$api.getUserList(searchForm);
            case 2:
              res = _context3.v;
              _this4.userList = res.data.list;
              _this4.userTableLoading = false;
              _this4.getUserScoreList(_this4.userList);
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getUserScoreList: function getUserScoreList(data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                if ((item === null || item === void 0 ? void 0 : item.user_type) === 3) userIds.push(item.id);
              });
              userIds = _toConsumableArray(new Set(userIds));
              if (userIds.length) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return _this5.$api.queryQuarterScoreById({
                userIds: userIds
              });
            case 2:
              res = _context4.v;
              if (res && res.data.length) {
                data.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.id;
                  });
                  _this5.$set(item, 'userScore', userScore || {});
                });
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateCouponTemplateStatus: function updateCouponTemplateStatus(row) {
      var _this6 = this;
      var status = row.status === 1 ? 0 : 1;
      this.$confirm("\u786E\u5B9A".concat(status === 1 ? '启用' : '停用', "\u8BE5\u4F18\u60E0\u5238\u5417\uFF1F")).then(function () {
        _this6.$api.updateCouponTemplateStatus({
          id: row.id,
          status: status,
          adminId: util.cookies.get("uuid")
        }).then(function () {
          _this6.$message.success("".concat(status === 1 ? '启用' : '停用', "\u6210\u529F"));
          _this6.getData();
        });

        // 操作上报
        _this6.$operationLog.push({
          code: status == 1 ? "open" : "close",
          operationType: "coupon_configure",
          detailBatchNo: row.code
        });
      }).catch(function () {});
    },
    usageTypeChange: function usageTypeChange(val) {
      var _this7 = this;
      this.couponTemplateConfig.usageType.map(function (item) {
        if (item.value === val) {
          _this7.form.chineseTitle = item.rule.chineseTitle;
          _this7.form.englishTitle = item.rule.englishTitle;
          _this7.form.traditionalTitle = item.rule.traditionalTitle;
          _this7.form.chineseRule = item.rule.chineseRule;
          _this7.form.englishRule = item.rule.englishRule;
          _this7.form.traditionalRule = item.rule.traditionalRule;
        }
      });
    },
    addCouponTemplate: function addCouponTemplate() {
      var _this8 = this;
      this.$refs.addForm.validate(function (valid) {
        console.log(valid);
        if (valid) {
          if (_this8.form.discountType === 0) {
            _this8.form.discountRate = parseFloat(_this8.form.discountRate);
            if (isNaN(_this8.form.discountRate) || _this8.form.discountRate < 0.1 || _this8.form.discountRate > 9.9) {
              _this8.$message.error("折扣率必须在0.1-9.9之间");
              return;
            }
          }
          _this8.form.adminId = util.cookies.get("uuid");
          _this8.$api.addCouponTemplate(_this8.form).then(function (res) {
            console.log(res);
            if (res.code === 200) {
              _this8.$message.success("新增成功");
              _this8.dialogVisible = false;
              _this8.getData();

              // 操作上报
              _this8.$operationLog.push({
                code: "add",
                operationType: "coupon_configure",
                detailBatchNo: res.data.code
              });
            }
          });
        }
      });
    },
    showDialog: function showDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          discountType: row.discountType,
          discountRate: row.discountRate,
          usageType: row.usageType,
          validDays: row.validDays,
          distributionType: row.distributionType,
          triggerCondition: row.triggerCondition,
          chineseTitle: row.chineseTitle,
          englishTitle: row.englishTitle,
          traditionalTitle: row.traditionalTitle,
          chineseRule: row.chineseRule,
          englishRule: row.englishRule,
          traditionalRule: row.traditionalRule
        };
      } else {
        this.form = {
          discountType: 0,
          discountRate: '',
          usageType: "",
          validDays: "",
          distributionType: "",
          triggerCondition: "",
          chineseTitle: "",
          englishTitle: "",
          traditionalTitle: "",
          chineseRule: "",
          englishRule: "",
          traditionalRule: ""
        };
      }
      this.dialogVisible = true;
    },
    getCouponTemplateConfig: function getCouponTemplateConfig() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this9.$api.getCouponTemplateConfig();
            case 1:
              res = _context5.v;
              _this9.couponTemplateConfig = res.data;
              _this9.form.discountType = _this9.couponTemplateConfig.discountType[0].value;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    resetForm: function resetForm() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        status: "",
        code: "",
        usageType: "",
        discountType: "",
        validDays: "",
        distributionType: "",
        triggerCondition: ""
      };
      this.getData('search');
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _res$data$content;
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this0.searchForm.pageNum = 1;
              }
              _this0.tableLoading = true;
              _context6.n = 1;
              return _this0.$api.getCouponTemplateList(_this0.searchForm);
            case 1:
              res = _context6.v;
              (_res$data$content = res.data.content) === null || _res$data$content === void 0 || _res$data$content.forEach(function (item) {
                item.createTime = dayjs(item.createTime * 1000).format("YYYY-MM-DD HH:mm");
              });
              _this0.tableData = res.data.content;
              _this0.total = res.data.totalSize;
              _this0.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    closeCouponDialog: function closeCouponDialog() {
      var _this1 = this;
      this.$nextTick(function () {
        _this1.$refs.addForm.clearValidate();
        _this1.$refs.addForm.resetFields();
      });
    }
  }
};